module.exports = __webpack_public_path__ + "static/media/PM126.76ef84bb.png";